import React, { Component } from 'react';
import { CircularProgress } from '@mui/material';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { COLORS } from '../../utils/Application_Constants';
import { WithContexts } from '../../contexts/withContexts';
import UserContext from '../../contexts/userContext';
import DashboardL1 from './DashboardL1';
import DashboardL2 from './DashboardL2';

const styles = () => ({
    root: {
        backgroundColor: COLORS.BLACK_HAZE,
        paddingBottom: '30px',
        minHeight: '800px',
    },
    activeAssignmentRoot: {
        marginTop: '30px',
        paddingTop: '30px',
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
    },
    upcomingAssignmentRoot: {
        marginTop: '30px',
        paddingTop: '30px',
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
    },
    progressWrapper: {
        height: '80vh',
    },
    progressRoot: {
        marginTop: '25vh',
    },
});
class DashboardWrapper extends Component {
    constructor(props, context) {
        super(props);
        const { PageContext: { setPageName } = {} } = this.props;
        setPageName('');
        this.state = {
            userLevelHasProcessed: false,
        };
        this.context = context;
    }

    componentDidMount() {
        this.pollUserLevel();
    }

    componentWillUnmount() {
        if (this.pollIntervalId) {
            clearInterval(this.pollIntervalId);
        }
    }

    pollUserLevel = () => {
        const { userLevel } = this.context;
        this.pollIntervalId = setInterval(() => {
            if (userLevel?.isFulfilled?.()) {
                this.userLevelFulfilled();
                clearInterval(this.pollIntervalId);
            }
        }, 250);
    };

    userLevelFulfilled = () => {
        this.setState({ userLevelHasProcessed: true });
    };

    render() {
        const { classes } = this.props;
        const { userLevelHasProcessed } = this.state;

        if (userLevelHasProcessed === false) {
            return (
                <div className={classes.progressWrapper}>
                    <CircularProgress classes={{ root: classes.progressRoot }} color="primary" />
                </div>
            );
        }

        if (userLevelHasProcessed === true) {
            const { userLevel } = this.context;
            return userLevel.value() === 1 ? (
                <DashboardL1 classes={classes} />
            ) : (
                <DashboardL2 classes={classes} />
            );
        }
    }
}

DashboardWrapper.propTypes = {
    classes: PropTypes.shape({
        root: PropTypes.string.isRequired,
    }).isRequired,
};

DashboardWrapper.contextType = UserContext;
export default WithContexts(withStyles(styles)(DashboardWrapper));
